module.exports = __webpack_public_path__ + "static/media/restaurant-food1.1f72cd11.jpeg";